export default { 
  
  SET_PARTIDA_SELECT (state, value) {
    state.partida = value
  },

  SET_INDEX (state, value) {
    state.index = value
  }
}